module.exports = __webpack_public_path__ + "img/pd_D1.2.3.842e0d42.png";